<template>
<div>
  <div class="shootPage" v-if="pcShow">
    <headerTitle indexInit="1"/>
    <carouselPics :pics="pics" carouselIndex="1"/>
    <div class="block_div"></div>
    <titleBlock textChinese="直播代播服务" textEnglish="SHOOTING  SERVICE" showChineseIndex="1"/>
    <div class="block_div"></div>
    <img class="pics_each" :src="shootVideo.url" />
    <div class="block_div"></div>
    
    <titleBlock textChinese="团队构成" textEnglish="TEAM  COMPOSITION" />
    <div class="block_div"></div>
    <serviceProjectShoot/>
    <div class="block_div"></div>
    
    
    
    <serviceProgressShoot />
    <div class="block_div"></div>
    <titleBlock textChinese="服务过的客户" textEnglish="COOPERATION PARTNERS"/>
    <div class="block_div"></div>
    <serviceClientShoot />
    <div class="block_div"></div>
    <!-- <serviceAdvancedTextThree />
    <div class="block_div"></div>
    <titleBlock textChinese="服务项目" textEnglish="SERVICE  PROJECT"/>
    <div class="block_div"></div>
    <div class="block_div"></div>
    <div class="block_div"></div>
     <titleBlock textChinese="知识达人" textEnglish="KNOWLEDGE  TALENT"/>
    <div class="block_div"></div>
     <knowledgeTalent />
    <div class="block_div"></div> 
    <videoBlockSelectOdd :videoArray="videoArraySelect" @selectPics="selectPics"/>
    <div class="block_div"></div> -->
    <footerBlock />
    <!-- <videoEachBlock @closeVideoFn="closeVideoFn" :videoUrl="videoUrl" v-if="videoFlag"/> -->
    
  </div>
  <div v-if="!pcShow" class="mobile_shootPage">
      <mobileHeader indexInit="1"/>
      <mobileCarousel :pics="images" carouselIndex="1"/>
      <mobileDivBlock />
      <mobileTitleBlock textChinese="直播代播服务" textEnglish="SHOOTING  SERVICE" showChineseIndex="1"/>
      <mobileDivBlock />
      <img class="pics_each" :src="shootVideo.url" />
      <mobileDivBlock />
      <mobileTitleBlock textChinese="团队构成" textEnglish="TEAM  COMPOSITION" />
    <mobileDivBlock />
    <mobileserviceProjectShoot/>
    <mobileDivBlock />
     <mobileprogresss />
       <mobileDivBlock />
    <mobileTitleBlock textChinese="服务过的客户" textEnglish="COOPERATION PARTNERS"/>
    <mobileDivBlock />
    
    <mobileserviceClientShoot />
   
    <mobileDivBlock />
    <mobilefooterBlock />
 
  </div>
  </div>
</template>

<script>
// @ is an alias to /src
import carouselPics from '@/components/carouselPics.vue'
import headerTitle from '@/components/headerTitle.vue'
import titleBlock from '@/components/titleBlock.vue'
import serviceBlock from '@/components/serviceBlock.vue'
import videoBlock from '@/components/videoBlock.vue'
import videoBlockSelectOdd from '@/components/videoBlockSelectOdd.vue'
import serviceProgressShoot from '@/components/serviceProgressShoot.vue'
import serviceClientShoot from '@/components/serviceClientShoot.vue'
import footerBlock from '@/components/footerBlock.vue'
import serviceAdvanced from '@/components/serviceAdvanced.vue'
import serviceAdvancedTextThree from '@/components/serviceAdvancedTextThree.vue'
import shootingCommon from '@/components/shootingCommon.vue'
import serviceProjectShoot from '@/components/serviceProjectShoot.vue'
import knowledgeTalent from '@/components/knowledgeTalent.vue'
import videoEachBlock from '@/components/videoEachBlock.vue'
import mobileHeader from "@/components/mobileHeader.vue";
import mobileCarousel from "@/components/mobileCarousel.vue";
import mobileDivBlock from "@/components/mobileDivBlock.vue";
import mobileTitleBlock from "@/components/mobileTitleBlock.vue";
import mobileServiceBlockBuss from "@/components/mobileServiceBlockBuss.vue";
import mobileserviceAdvancedText from "@/components/mobileserviceAdvancedText.vue";
import mobileourService from "@/components/mobileourService.vue";
import mobileshooting from "@/components/mobileshooting.vue";
import mobileprogress from "@/components/mobileprogress.vue";
import mobilefooterBlock from "@/components/mobilefooterBlock.vue";
import mobilevideoBlockSelect from "@/components/mobilevideoBlockSelect.vue";
import mobileserviceClient from "@/components/mobileserviceClient.vue";
import mobileserviceProjectShoot from "@/components/mobileserviceProjectShoot.vue";
import mobileserviceClientShoot from "@/components/mobileserviceClientShoot.vue";
import mobileprogresss from "@/components/mobileprogresss.vue";







export default {
  name: 'videocourse',
  data() {
    return {
      pics:[
        {url:require('@/assets/imgs/banner1001.jpeg'),linerow:6,style:'margin-left:50px;text-align:left',text:'<span style="font-size:62px;color:#e91d62">低成本实现销量暴增</span>'},
        // {url:require('@/assets/imgs/banner02.jpeg'),text:'你好'},
        // {url:require('@/assets/imgs/banner03.jpeg'),text:'你好'},
        // {url:require('@/assets/imgs/banner04.jpeg'),text:'你好'} 
      ],
      videoUrl:{},
      videoFlag:false,
      shootVideo:{url:require('@/assets/imgs/shootPic.png')},
      videoArray:[
        [{url:require('@/assets/video/video503.jpg'),text:'清华博士带你走进迷你实验室',videoUrl:require('@/assets/video/video503.mp4')},
        {url:require('@/assets/video/video504.jpg'),text:'品读经典诗句 掌握写作技巧',videoUrl:require('@/assets/video/video504.mp4')}],
        [{url:require('@/assets/video/video505.jpg'),text:'《趣说文物巧学成语》朋朋哥哥带你逛博物馆',videoUrl:require('@/assets/video/video505.mp4')},
        {url:require('@/assets/video/video506.jpg'),text:'红楼梦趣味跟读——跟大师学写作',videoUrl:require('@/assets/video/video506.mp4')}],
        [{url:require('@/assets/video/video507.jpg'),text:'九大诗人趣味故事',videoUrl:require('@/assets/video/video507.mp4')},
        {url:require('@/assets/video/video508.jpg'),text:'零基础掌握记忆法',videoUrl:require('@/assets/video/video508.mp4')}],
         [{url:require('@/assets/video/video509.jpg'),text:'森林里的诗词课',videoUrl:require('@/assets/video/video509.mp4')},
        {url:require('@/assets/video/video502.jpg'),text:'航空航天知识科普',videoUrl:require('@/assets/video/video502.mp4')}],
        
      ],
      videoArraySelect:[
        {url:require('@/assets/video/video503.jpg'),text:'清华博士带你走进迷你实验室',videoUrl:require('@/assets/video/video503.mp4')},
        {url:require('@/assets/video/video504.jpg'),text:'品读经典诗句 掌握写作技巧',videoUrl:require('@/assets/video/video504.mp4')},
        {url:require('@/assets/video/video505.jpg'),text:'《趣说文物巧学成语》朋朋哥哥带你逛博物馆',videoUrl:require('@/assets/video/video505.mp4')},
        {url:require('@/assets/video/video506.jpg'),text:'红楼梦趣味跟读——跟大师学写作',videoUrl:require('@/assets/video/video506.mp4')},
        {url:require('@/assets/video/video507.jpg'),text:'九大诗人趣味故事',videoUrl:require('@/assets/video/video507.mp4')},
        {url:require('@/assets/video/video508.jpg'),text:'零基础掌握记忆法',videoUrl:require('@/assets/video/video508.mp4')},
         {url:require('@/assets/video/video509.jpg'),text:'森林里的诗词课',videoUrl:require('@/assets/video/video509.mp4')},
        {url:require('@/assets/video/video502.jpg'),text:'航空航天知识科普',videoUrl:require('@/assets/video/video502.mp4')},
      ],
      pcShow: false,
      images: [
        {url:require('@/assets/imgs/banner1001.jpeg'),linerow:6,style:'margin-left:50px;text-align:left',text:'<span style="font-size:16px;color:#e91d62">低成本实现销量暴增</span>'},
      ],
    }
  },
  components: {
    carouselPics,
    headerTitle,
    titleBlock,
    serviceBlock,
    videoBlock,
    serviceProgressShoot,
    serviceClientShoot,
    footerBlock,
    serviceAdvanced,
    serviceAdvancedTextThree,
    shootingCommon,
    serviceProjectShoot,
    knowledgeTalent,
    videoEachBlock,
    videoBlockSelectOdd,
    mobileHeader,
    mobileCarousel,
    mobileDivBlock,
    mobileTitleBlock,
    mobileServiceBlockBuss,
    mobileserviceAdvancedText,
    mobileourService,
    mobileshooting,
    mobileprogress,
    mobilefooterBlock,
    mobilevideoBlockSelect,
    mobileserviceClient,
    mobileserviceProjectShoot,
    mobileserviceClientShoot,
    mobileprogresss
  },
  mounted() {
    this.widthChange();
    window.addEventListener("resize", this.widthChange);
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
  methods:{
    widthChange() {
      console.log(123333);
      let clientWidthW = document.body.clientWidth;
      console.log(this.pcShow, "999000this.pcShow");
      console.log(clientWidthW, "9900");
      if (clientWidthW < 768) {
        this.pcShow = false;
      } else {
        this.pcShow = true;
      }
    },
    closeVideoFn(){
      this.videoFlag = false
    },
    selectPics(item){
      this.videoFlag = true
      this.videoUrl.videoUrl = item.videoUrl
      // this.videoUrl.videoUrl = this.videoArray[index][inx].videoUrl
      console.log(this.videoUrl,'this.videoUrl')
    }
  },
}
</script>
<style lang="less">
.shootPage{
  .pics_each{
    width: 100%;
  }
}
.mobile_shootPage{
  .pics_each{
    width: 100%;
  }
}
</style>
